import store from "../store/store";

export async function backgroundSync () {
  try {
    store.dispatch("customers/uploadUpdated");
    store.dispatch("shifts/uploadUpdated");
    store.commit("orders/updateLocalIds");
    store.dispatch("config/uploadUpdatedTables");
  } catch (e) {
    console.error(e);
  }
}
